/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon32Regular = forwardRef('ArrowUiCornerOutUpRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8.5 5A3.5 3.5 0 0 0 5 8.5v15A3.5 3.5 0 0 0 8.5 27h15a3.5 3.5 0 0 0 3.5-3.5V20a1 1 0 1 1 2 0v3.5a5.5 5.5 0 0 1-5.5 5.5h-15A5.5 5.5 0 0 1 3 23.5v-15A5.5 5.5 0 0 1 8.5 3H12a1 1 0 1 1 0 2H8.5Z" }),
        React.createElement("path", { d: "M27 6.414V13a1 1 0 1 0 2 0V5a2 2 0 0 0-2-2h-8a1 1 0 1 0 0 2h6.586L15.293 15.293a1 1 0 0 0 1.414 1.414L27 6.414Z" })));
});
